export default __webpack_public_path__ + "static/media/Unicast-2-broken-links.0968b732.mp4";